// GENERATED by scripts/gen-locale-bundles.mjs — do not edit by hand.
// Locale: ja. Source: ja/global.json (Smartling-owned).
export default {
  "footer.link.apiNetwork.appSecurity": "アプリケーションセキュリティ",
  "footer.link.apiNetwork.artificialIntelligence": "人工知能",
  "footer.link.apiNetwork.communication": "コミュニケーション",
  "footer.link.apiNetwork.dataAnalytics": "データ分析",
  "footer.link.apiNetwork.database": "データベース",
  "footer.link.apiNetwork.developerProductivity": "開発者の生産性",
  "footer.link.apiNetwork.devops": "DevOps",
  "footer.link.apiNetwork.eCommerce": "Eコマース",
  "footer.link.apiNetwork.eSignature": "電子署名",
  "footer.link.apiNetwork.financialServices": "金融サービス",
  "footer.link.apiNetwork.payments": "決済",
  "footer.link.apiNetwork.travel": "旅行",
  "footer.link.company.about": "会社概要",
  "footer.link.company.careersAndCulture": "採用情報と企業文化",
  "footer.link.company.contactUs": "お問い合わせ",
  "footer.link.company.customerStories": "導入事例",
  "footer.link.company.partnerProgram": "パートナープログラム",
  "footer.link.company.pressAndMedia": "プレス・メディア",
  "footer.link.downloadPostman": "Postmanをダウンロード",
  "footer.link.legalSecurity.legalTermsHub": "法務関連情報",
  "footer.link.legalSecurity.postmanProductTerms": "Postman製品利用規約",
  "footer.link.legalSecurity.security": "セキュリティ",
  "footer.link.legalSecurity.termsOfService": "利用規約",
  "footer.link.legalSecurity.websiteTermsOfUse": "ウェブサイト利用規約",
  "footer.link.privacyPolicy": "プライバシーポリシー",
  "footer.link.product.agentMode": "Agent Mode",
  "footer.link.product.apiCatalog": "API Catalog",
  "footer.link.product.enterprise": "Enterprise",
  "footer.link.product.fern": "Fern",
  "footer.link.product.flows": "Flows",
  "footer.link.product.integrations": "統合",
  "footer.link.product.plansAndPricing": "プランと価格",
  "footer.link.product.postmanCli": "Postman CLI",
  "footer.link.product.postmanOverview": "Postmanの概要",
  "footer.link.product.specHub": "Spec Hub",
  "footer.link.product.workspaces": "Workspaces",
  "footer.link.resources.academy": "Academy",
  "footer.link.resources.community": "コミュニティ",
  "footer.link.resources.intergalactic": "Intergalactic",
  "footer.link.resources.mcpServers": "MCP Servers",
  "footer.link.resources.postmanDocs": "Postmanドキュメント",
  "footer.link.resources.videos": "動画",
  "footer.section.apiNetwork": "API Network",
  "footer.section.company": "会社情報",
  "footer.section.languages": "言語",
  "footer.section.legalAndSecurity": "法務とセキュリティ",
  "footer.section.product": "製品",
  "footer.section.resources": "リソース",
  "lang.selectLanguage": "言語",
  "nav.contactSales": "営業に問い合わせ",
  "nav.dropdowns.product.brands.astroAi.description": "本番環境のAIエージェントを管理・制御",
  "nav.dropdowns.product.brands.astroAi.title": "Astro AI",
  "nav.dropdowns.product.brands.fabricGateway.description": "AIトラフィックのルーティング、ガバナンス、オブザーバビリティを実現",
  "nav.dropdowns.product.brands.fabricGateway.title": "Fabric",
  "nav.dropdowns.product.brands.fern.description": "APIドキュメントとSDKをすぐに生成",
  "nav.dropdowns.product.brands.fern.title": "Fern",
  "nav.dropdowns.product.brands.heading": "Postmanのその他の製品",
  "nav.dropdowns.product.designBuild.documents.title": "Documents",
  "nav.dropdowns.product.designBuild.flows.title": "Flows",
  "nav.dropdowns.product.designBuild.mockServers.title": "Mock Servers",
  "nav.dropdowns.product.designBuild.sdkGenerator.title": "SDK Generator",
  "nav.dropdowns.product.designBuild.specHub.title": "Spec Hub",
  "nav.dropdowns.product.designBuild.title": "設計とビルド",
  "nav.dropdowns.product.designBuild.workspaces.title": "Workspaces",
  "nav.dropdowns.product.featured.agentMode.description": "ネイティブAIでAPIワークフローを自動化",
  "nav.dropdowns.product.featured.agentMode.title": "Agent Mode",
  "nav.dropdowns.product.featured.aiEngineer.description": "エージェントで開発を加速し、品質とセキュリティを維持",
  "nav.dropdowns.product.featured.aiEngineer.title": "AI Engineer",
  "nav.dropdowns.product.featured.postmanCli.description": "コマンドラインからPostmanを利用",
  "nav.dropdowns.product.featured.postmanCli.title": "Postman CLI",
  "nav.dropdowns.product.featured.postmanMcpServer.description": "AIエージェントにAPIコンテキストを提供",
  "nav.dropdowns.product.featured.postmanMcpServer.title": "Postman MCP Server",
  "nav.dropdowns.product.manageOperate.apiCatalog.title": "API Catalog",
  "nav.dropdowns.product.manageOperate.applicationInventory.title": "Application Inventory",
  "nav.dropdowns.product.manageOperate.insights.title": "Insights",
  "nav.dropdowns.product.manageOperate.title": "管理と運用",
  "nav.dropdowns.product.platform.apiNetwork": "Postman API Network",
  "nav.dropdowns.product.platform.downloadPostman": "Postmanをダウンロード →",
  "nav.dropdowns.product.platform.explore": "探索",
  "nav.dropdowns.product.platform.integrations": "統合",
  "nav.dropdowns.product.platform.mcpServerCatalog": "MCP Server Catalog",
  "nav.dropdowns.product.platform.security": "セキュリティ",
  "nav.dropdowns.product.platform.title": "プラットフォーム",
  "nav.dropdowns.product.platform.whatsNew": "新着情報",
  "nav.dropdowns.product.testValidate.apiClient.title": "API Client",
  "nav.dropdowns.product.testValidate.collectionRunner.title": "Collection Runner",
  "nav.dropdowns.product.testValidate.dataDrivenTesting.title": "データドリブンテスト",
  "nav.dropdowns.product.testValidate.functionalTesting.title": "機能テスト",
  "nav.dropdowns.product.testValidate.monitors.title": "Monitors",
  "nav.dropdowns.product.testValidate.performanceTesting.title": "パフォーマンステスト",
  "nav.dropdowns.product.testValidate.title": "テストと検証",
  "nav.dropdowns.product.testValidate.webhooks.title": "Webhookテスト",
  "nav.dropdowns.resources.connect.community": "コミュニティ",
  "nav.dropdowns.resources.connect.discord": "Discord",
  "nav.dropdowns.resources.connect.events": "イベント",
  "nav.dropdowns.resources.connect.mcpServer": "Postman MCP Server",
  "nav.dropdowns.resources.connect.partnerProgram": "パートナープログラム",
  "nav.dropdowns.resources.connect.title": "つながる",
  "nav.dropdowns.resources.getSupport.releaseNotes": "リリースノート",
  "nav.dropdowns.resources.getSupport.security": "セキュリティ",
  "nav.dropdowns.resources.getSupport.status": "Postman Status",
  "nav.dropdowns.resources.getSupport.supportCenter": "サポートセンター",
  "nav.dropdowns.resources.getSupport.title": "サポート",
  "nav.dropdowns.resources.learn.academy": "Postman Academy",
  "nav.dropdowns.resources.learn.bestPractices": "Postmanベストプラクティス",
  "nav.dropdowns.resources.learn.customerStories": "導入事例",
  "nav.dropdowns.resources.learn.docs": "ドキュメント",
  "nav.dropdowns.resources.learn.enterpriseOnboarding": "エンタープライズオンボーディング",
  "nav.dropdowns.resources.learn.learningHub": "学習ハブ",
  "nav.dropdowns.resources.learn.title": "学ぶ",
  "nav.dropdowns.resources.postman.aboutPostman": "Postmanについて",
  "nav.dropdowns.resources.postman.blog": "ブログ",
  "nav.dropdowns.resources.postman.pressMedia": "プレス・メディア",
  "nav.dropdowns.resources.postman.title": "Postman",
  "nav.dropdowns.resources.tools.apiDesigner": "APIデザイナー",
  "nav.dropdowns.resources.tools.loadTest": "API負荷テスト",
  "nav.dropdowns.resources.tools.monitorMultistep": "複数ステップのAPIモニター",
  "nav.dropdowns.resources.tools.seeAll": "すべてのツールを見る →",
  "nav.dropdowns.resources.tools.specEditor": "OpenAPIエディターとビジュアライザー",
  "nav.dropdowns.resources.tools.title": "ツール",
  "nav.dropdowns.resources.tools.unitTestGenerator": "AI単体テストジェネレーター",
  "nav.dropdowns.solutions.apiGovernance.description": "API標準を組織全体で適用",
  "nav.dropdowns.solutions.apiGovernance.title": "APIガバナンス",
  "nav.dropdowns.solutions.apiLifecycle.description": "APIライフサイクル全体を一つのシステムで管理",
  "nav.dropdowns.solutions.apiLifecycle.title": "APIライフサイクル管理",
  "nav.dropdowns.solutions.partnerApi.description": "数日でパートナーの利用を開始",
  "nav.dropdowns.solutions.partnerApi.title": "パートナーAPI管理",
  "nav.dropdowns.solutions.sdlcAutomation.description": "デリバリーのあらゆる段階に品質を組み込む",
  "nav.dropdowns.solutions.sdlcAutomation.title": "SDLC自動化",
  "nav.homeLabel": "ホーム",
  "nav.launchPostman": "Postmanを起動",
  "nav.menus.enterprise": "エンタープライズ",
  "nav.menus.pricing": "価格",
  "nav.menus.product": "製品",
  "nav.menus.resources": "リソース",
  "nav.menus.solutions": "ソリューション",
  "nav.signIn": "サインイン",
  "nav.signUp": "無料で登録",
  "nav.toggleMenu": "ナビゲーションメニューを切り替える"
};
